import { FilterableDimension } from 'modules/analytics/models/dimensions/FilterableDimension';
export class EventDimension extends FilterableDimension {
    static $inject = ['init'];
    constructor(init) {
        super();
        Object.assign(this, init);
    }
}
EventDimension.$inject = ['init'];
